import React, { useEffect, useState } from "react";
import BasicHeaderLayout from "../../../../layouts/BasicHeaderLayout/BasicHeaderLayout";
import { AppManager } from "../../../../manager";
import Loading from "../../../../components/Loading/Loading";
import BasicErrorView from "../../../../components/ErrorView/BasicErrorView/BasicErrorView";
import { useRouteMatch } from "react-router-dom";
import { TOrgInvitation } from "../../../../models/Organization/Types";
import AppContent from "../../../../containers/AppContent/AppContent";
import { Card, Modal, Button } from "antd";
import { Checkmark } from "react-checkmark";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/reducers";
import { Organization } from "../../../../models/Organization/Organization";
import Styles from "./AcceptRequestPage.scss";
import CheckIcon from "@ant-design/icons/CheckOutlined";

const AcceptRequestPage = () => {
    const [loading, setLoading] = useState(true);
    const [accepting, setAccepting] = useState(false);
    const [completed, setCompleted] = useState(false);
    const [organizationId, setOrganizationId] = useState("");
    const [authAccessToken, setAuthAccessToken] = useState("");
    const [pageError, setPageError] = useState<string>();
    const [invitationAttr, setInvitationAttr] = useState<TOrgInvitation>();
    const routeMatch = useRouteMatch();
    const activeOrg = useSelector<RootState, Organization | undefined>((s) => s.orgs.activeOrg);

    const handleAcceptInvitation = () => {
        setAccepting(true);
        AppManager.ephemeral.apiAcceptDealerGroupRequest(authAccessToken, organizationId, (err) => {
            setAccepting(false);
            if (err) setPageError(`${err}`);
            else setCompleted(true);
        });
    };

    useEffect(() => {
        if (!routeMatch.isExact) AppManager.route.gotoHome();

        const { authToken: token, organizationId: orgId } = routeMatch.params as any;
        setOrganizationId(orgId);
        setAuthAccessToken(token);
        AppManager.ephemeral.setAccessToken(token);
        AppManager.ephemeral.apiLoadOrganization(token, orgId, (err, resp) => {
            if (err) {
                setLoading(false);
                setPageError(err);
            } else {
                AppManager.ephemeral.apiLoadDealerGroupRequestAttrs(token, orgId, (err, data) => {
                    setLoading(false);
                    if (err) setPageError(err);
                    else if (!data) {
                        setPageError("Not found or not authorized");
                    } else {
                        setInvitationAttr(data);
                    }
                });
            }
        });
    }, []);

    return (
        <BasicHeaderLayout title="Dealer Group Request">
            <AppContent header="" showNetworkState={false}>
                <Card className={Styles.CardContainer}>
                    {pageError ? (
                        <BasicErrorView error={pageError} />
                    ) : loading || !invitationAttr ? (
                        <Loading text="Loading..." />
                    ) : completed ? (
                        <div className={Styles.FinalViewContent}>
                            <div className={Styles.FinalViewCheckmark}>
                                <Checkmark size={128} color="#40c475" />
                            </div>
                            <h1 className={Styles.FinalViewHeader}>Everything went well 🙂</h1>
                            <div>
                                You can now
                                <Button danger size="small" onClick={() => close()} style={{ margin: "0 5px" }}>
                                    close
                                </Button>
                                this browser tab
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className={Styles.Header}>
                                Your dealer group organization will have access to the information of{" "}
                                {activeOrg?.data.attrs.name || "this organization"} after the invite is accepted
                            </div>
                            <div className={Styles.ActionButton}>
                                <Button
                                    icon={<CheckIcon />}
                                    size="large"
                                    type="primary"
                                    onClick={handleAcceptInvitation}
                                    loading={accepting}
                                    disabled={accepting}
                                >
                                    Accept Invitation
                                </Button>
                            </div>
                        </>
                    )}
                </Card>
            </AppContent>
        </BasicHeaderLayout>
    );
};

export default AcceptRequestPage;
